var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "support-copy",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,8 L12,11.5 L11.295,10.795 L14.085,8 L11.295,5.205 L12,4.5 L15.5,8 L15.5,8 Z M0.5,8 L4,4.5 L4.705,5.205 L1.915,8 L4.705,10.795 L4,11.5 L0.5,8 L0.5,8 Z M6.20925398,12.741832 L8.81944405,3.00047006 L9.78536987,3.25928911 L7.1751798,13.0006511 L6.20925398,12.741832 Z",
    id: "icon-color"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportCopy);
export default __webpack_public_path__ + "static/media/support-copy.8a8f129e5933f838daa3bc039a16f2b5.svg";
export { ForwardRef as ReactComponent };